import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	exportIssuesAlreadyInProgressTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportIssuesAlreadyInProgressDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportIssuesAlreadyInProgressCancelExportAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	exportIssuesAlreadyInProgressTitle: {
		id: 'issue-navigator-action-export-issues.common.export-issues-already-in-progress-title',
		defaultMessage: '{exportItemLabel} already in progress',
		description:
			'Title of export issues already in progress error flag, where {exportItemLabel} is the label of the selected option (like "CSV export (all fields)")',
	},
	exportIssuesAlreadyInProgressDescription: {
		id: 'issue-navigator-action-export-issues.common.export-issues-already-in-progress-description',
		defaultMessage: 'Wait for the export to complete, or cancel and start again.',
		description: 'Desription of export issues already in progress error flag.',
	},
	exportIssuesAlreadyInProgressCancelExportAction: {
		id: 'issue-navigator-action-export-issues.common.export-issues-already-in-progress-cancel-export-action',
		defaultMessage: 'Cancel export',
		description: 'Label displayed on cancel export button',
	},
});

export default messages;
